// extracted by mini-css-extract-plugin
export default {"root":"FeedbackNPS_root__A2lSU","layout-container":"FeedbackNPS_layout-container__JEUVI","content":"FeedbackNPS_content__f5m-I","buttonClose":"FeedbackNPS_buttonClose__IamIE","text":"FeedbackNPS_text__jwgjz","buttonSubmit":"FeedbackNPS_buttonSubmit__PvCxK","stars":"FeedbackNPS_stars__diKng","glow":"FeedbackNPS_glow__6I9vd"};
    if(module.hot) {
      // 1763446807813
      var cssReload = require("/usr/src/app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  